import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatableserver";
// import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
  name: "CreateProgPage",
  data() {
    let ss = new MainService();
    return {
      msg: "CreateProgPage",
      ss: ss,
      ajax: {
        url: ss.indexCreateProg(),
        headers: ss.getToken(),
      },
      columns: [
        {
          data: "id",
          name: "id",
          orderable: false,
          searchable: false,
          visible: false,
        },
        {
          data: "DT_RowIndex",
          name: "DT_RowIndex",
          title: "N°",
          orderable: false,
          searchable: false,
        },
        { data: "paterno", name: "paterno", title: "Paterno" },
        { data: "materno", name: "materno", title: "Materno" },
        { data: "nombre", name: "nombre", title: "Nombre" },
        { data: "ci", name: "ci", title: "CI" },
        // { data: "carrera.Carrera", name: "Carrera", title: "Carrera" },

        {
          data: "action",
          orderable: false,
          title: "Acciones",
          searchable: false,
        },
      ],
      createprogs: [],
      createprog: {
        nota_d: "", // Inicializar nota_d aquí
        pdf: "", // Inicializar pdf aquí
        nivel: "",
        Idioma: "",
        Carera: "",
      },
      isLoading: false,
      errorBag: {},
      gestion: null,
      carreras: "",
      unidadAcademica: "",
      idiomas: "",
      filterci: "",
    };
  },
  methods: {
    filterCreateProg() {
      this.errorBag = {};
      this.$refs["view-filter"].show();
    },
    filter() {
      this.isLoading = true;
      this.ss
        .filtradoCreateProg(this.filterci)
        .then((result) => {
          let response = result.data;
          this.createprog = response.data;
          this.gestion = response.gestion;
          this.instituciones = response.instituciones;
          this.idiomas = response.idiomas;
          this.carreras = response.carreras;
          this.unidadAcademica = response.unidadAcademica;
          this.$refs["view-createprog"].show();
          this.$refs["view-filter"].hide();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    showCreateProg(id) {
      this.isLoading = true;
      this.ss
        .showCreateProg(id)
        .then((result) => {
          let response = result.data;
          this.createprog = response.data;
          this.gestion = response.gestion;
          this.instituciones = response.instituciones;
          this.idiomas = response.idiomas;
          this.carreras = response.carreras;
          this.unidadAcademica = response.unidadAcademica;
          this.$refs["view-createprog"].show();
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
        });
    },
    editCreateProg() {
      this.$refs["frm-createprog"].show();
      this.$refs["view-createprog"].hide();
    },
    cancelCreateProg() {
      if (this.createprog.id) {
        this.$refs["view-createprog"].show();
      }
      this.$refs["frm-createprog"].hide();
    },
    saveCreateProg() {
      // Obtener el archivo seleccionado
      let file = document.querySelector('input[type="file"]').files[0];

      // Crear un FormData para enviar el archivo al backend
      let formData = new FormData();
      formData.append("File", file);

      // Enviar el archivo al backend utilizando la función uploadFile
      this.ss
        .uploadFile(formData)
        .then((response) => {
          this.createprog.pdf = response.data.data;
          // Guardar la instancia
          this.ss
            .storeCreateProg(this.createprog)
            .then((result) => {
              let response = result.data;
              this.$bvToast.toast(response.msg, {
                title: "Correcto",
                variant: "success",
                autoHideDelay: 5000,
              });
              this.$refs["frm-createprog"].hide();
              this.$refs["datatable-createprog"].reload();
            })
            .catch((error) => {
              this.errorBag = error.response.data.errors;
              this.$bvToast.toast(
                "Problema al Guardar el Registro, favor verificar los Datos",
                {
                  title: "Error",
                  variant: "danger",
                  autoHideDelay: 5000,
                }
              );
            });
        })
        .catch((error) => {
          // Aquí puedes manejar los errores, por ejemplo, mostrar un mensaje de error al usuario
        });
    },

    deleteCreateProg() {
      this.$swal({
        title: "¿Estás seguro que deseas eliminar?",
        text: "Esta acción es irreversible!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "Cancelar",
      }).then((result) => {
        if (result.isConfirmed) {
          this.ss
            .destroyCreateProg(this.createprog)
            .then((result) => {
              let response = result.data;
              this.$swal({
                title: "¡Eliminado!",
                text: "El archivo ha sido eliminado.",
                icon: "success",
              });
              this.$refs["view-createprog"].hide();
              this.$refs["datatable-createprog"].reload();
            })
            .catch((error) => {
            });
        }
      });
    },
    createCreateProg() {
      this.errorBag = {};
      this.createprog.gestion = document.querySelector(
        'input[name="gestion"]'
      ).value;
      this.createprog.motivo = document.querySelector(
        'input[name="motivo"]'
      ).value;
      this.createprog.nota_d = document.querySelector(
        'input[name="nota_d"]'
      ).value;

      this.ss
        .createcertCreateProg(this.createprog)
        .then((response) => {
          window.open(response.data.pdf_url);
          this.$refs["frm-createprog"].show();
          this.$refs["view-createprog"].hide();
        })
        .catch((error) => {
          this.errorBag = error.response.data.errors;
          this.$bvToast.toast(
            "Problema al Crear el Certificado, favor verificar los Datos",
            {
              title: "Error",
              variant: "danger",
              autoHideDelay: 5000,
            }
          );
        });
    },
    draw() {
      window.$(".btn-datatable-CreateProg").on("click", (evt) => {
        const data = window.$(evt.target)[0].id;
        this.showCreateProg(data);
      });
    },
  },
  components: {
    dataTable,
    // Loader
  },
  mounted() {
    var persona = JSON.parse(localStorage.getItem("persona"));
    if (!persona) {
      this.$router.push("/Login");
    }
  },
};
